import { useSelector } from 'react-redux'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { RATIO_COL_ID } from '../../../store/helper'
import { selectActiveRow, selectCellData } from '../../../store/slice'
import DynamicUnit from './DynamicUnit'
import LineChart from './LineChart'
import classes from './classes.module.scss'

const FIRST_CELL_INDEX = 0

const FinanceChart = ({ typePrefix }) => {
  const formatCurrency = useFormatCurrency(SCREEN.PORTFOLIO_INSIGHTS_FINANCE)

  const activeRow = useSelector(selectActiveRow(typePrefix))
  const val = useSelector(
    selectCellData(activeRow, FIRST_CELL_INDEX, RATIO_COL_ID, typePrefix),
  )

  return (
    <div className={classes.chartContainer}>
      <DynamicUnit val={val} formatCurrency={formatCurrency} />
      <LineChart
        typePrefix={typePrefix}
        formatCurrency={formatCurrency}
        val={val}
      />
    </div>
  )
}

export default FinanceChart
